(function () {
  function formatMoney(cents, format) {
    var fixed = (cents / 100).toFixed(2).split('.');
    var whole = fixed[0];
    var dec = fixed[1];
    var commas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var dots = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return commas;
        case 'amount_with_comma_separator': return dots + ',' + dec;
        case 'amount_no_decimals_with_comma_separator': return dots;
        default: return commas + '.' + dec;
      }
    });
  }

  // Product page: variant pills, price, quantity and gallery
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var json = root.querySelector('[data-product-json]');
    var form = root.querySelector('form.product-form');
    if (!json || !form) return;
    var data = JSON.parse(json.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var addButton = form.querySelector('[name="add"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare-price]');
    var fieldsets = root.querySelectorAll('[data-option-position]');

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function onOptionChange() {
      var options = selectedOptions();
      var variant = data.variants.find(function (v) {
        return v.options.every(function (value, i) { return value === options[i]; });
      });
      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      priceEl.textContent = formatMoney(variant.price, data.moneyFormat);
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price, data.moneyFormat);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? 'Add to cart' : 'Sold out';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', onOptionChange);
    });

    var qty = form.querySelector('input[name="quantity"]');
    form.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = (parseInt(qty.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10);
        qty.value = Math.max(1, next);
      });
    });

    var mainImage = root.querySelector('[data-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = thumb.dataset.thumb;
        mainImage.alt = thumb.dataset.alt || '';
        root.querySelectorAll('[data-thumb]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  });

  // Collection page: apply filters and sorting as soon as they change
  var filters = document.querySelector('form[data-auto-submit]');
  if (filters) {
    var submit = function () { filters.submit(); };
    filters.addEventListener('change', submit);
    var sort = document.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', submit);
  }
})();
